require('./expensesByCategoryViewNewTable.scss');

// @vendors
import React from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
const { FormattedText } = require('core/i18n').i18n;

// @components
import { OKLoadingErrorMessage } from "commonsComponents/OKLoadingErrorMessage";
import { EmptyState } from 'commonsComponents/emptyState';
import { OKButton } from 'components/commons/OKButton/OKButton';
import ExpensesByCategoryTable from '../expensesByCategoryTable/expensesByCategoryTable';
import MustRender from '../commons/components/MustRender'

// @helpers
import getFiltersRelatedToContractType from '../commons/helpers/getFiltersRelatedToContractType'
const { formatText } = require('core/i18n').i18n;

class ExpensesByCategoryViewNewTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            itemsToShow: 10
        }
    }

    componentDidUpdate(prevProps) {
        const { selectedCategory, getCategoryMovements } = this.props
        if (prevProps.selectedCategory.categoryCode !== selectedCategory.categoryCode) {
            getCategoryMovements(selectedCategory.categoryCode)
        }
    }

    buildMovementsTable = (filteredMovementsData, itemsToShow, immAccounts, immCards, isFetching, hasError) => {
        
        return (
            <OKLoadingErrorMessage
                isLoading={isFetching}
                isError={hasError}
            >
                {filteredMovementsData.size ?
                    (<React.Fragment>
                        <ExpensesByCategoryTable
                            canChangeCategory={this.props.canChangeCategory}
                            immAccounts={immAccounts}
                            immCards={immCards}
                            expensesByCategory={filteredMovementsData.slice(0, itemsToShow)}
                        />
                        <MustRender isTrueThat={filteredMovementsData.size >= itemsToShow}>
                            { this.buildShowMoreButton() }
                        </MustRender>
                    </React.Fragment>) :
                    (<EmptyState
                        primaryText={formatText('movements-emptyMovements')}
                        withMargin={false}
                        iconType="noitems-banking" />)}
            </OKLoadingErrorMessage>
        )
    }

    buildShowMoreButton = () => {
        return (
            <div className="expenses-by-category-table-container__link-container">
                <div className="expenses-by-category-table__previous-months">
                    <OKButton modifier="link-complementary" onClick={() => this.showMoreItems()}>
                        <FormattedText value="cards-seeMoreMovements" format={__CONTACT_CENTER__ ? 'uppercase' : null} />
                    </OKButton>
                </div>
            </div>
        )
    }

    getFilteredMovements = (immFilters, movementsData, hasAppliedFilters) => {
        if (!hasAppliedFilters) {
            return movementsData
        }
        const { isCreditFilterSelected, isDebitFilterSelected } = getFiltersRelatedToContractType(immFilters),
            CREDIT = 1,
            DEBIT = 0;
        let contractTypeFilters = [];

        if (isCreditFilterSelected) contractTypeFilters.push(CREDIT);
        if (isDebitFilterSelected) contractTypeFilters.push(DEBIT);
        return movementsData.filter(movement => this.selectMovementsAccordingToContractType(movement, contractTypeFilters), { contractTypeFilters })
    }

    selectMovementsAccordingToContractType  = (movement, contractTypeFilters) => contractTypeFilters.includes(movement.get('tipoCuenta'))

    showMoreItems = () => this.setState(state => ({
        itemsToShow: state.itemsToShow + 10,
    }))

    render() {
        const { itemsToShow } = this.state,
            { movementsData, immAccounts, immCards, immFilters, isFetching, hasError, hasAppliedFilters } = this.props,
            filteredMovementsData = this.getFilteredMovements(immFilters, movementsData, hasAppliedFilters);
            
        return (
            <section className="col-xs-12">
                <div className="expenses-by-category-table-container">
                    {this.buildMovementsTable(filteredMovementsData, itemsToShow, immAccounts, immCards, isFetching, hasError)}
                </div>
            </section>
        );
    }
}

ExpensesByCategoryViewNewTable.propTypes = {
    currency: PropTypes.string,
    immAccounts: PropTypes.object,
    immCards: PropTypes.object,
    immFilters: PropTypes.object,
    movementsData: PropTypes.object,
    isFetching: PropTypes.bool,
    hasAppliedFilters: PropTypes.bool,
    hasError: PropTypes.bool,
    getCategoryMovements: PropTypes.func,
    selectedCategory: PropTypes.object,
    setSelectFilter: PropTypes.func,
    setCheckFilter: PropTypes.func,
    setDateFilter: PropTypes.func,
    onFilter: PropTypes.func,
    canChangeCategory: PropTypes.bool
};

module.exports = connect(
    state => ({
        movementsData: state.expensesByCategoriesMovementsCategory.get('movementsData'),
        isFetching: state.expensesByCategoriesMovementsCategory.get('fetching'),
        hasError: state.expensesByCategoriesMovementsCategory.get('error'),
    }),
    null
)(ExpensesByCategoryViewNewTable);